module.exports = __webpack_public_path__ + "img/Trustpilot_brandmark_gr-wht_RGB.0aede8f7.svg";